import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CalendarClock, LayoutDashboard, FileText, Receipt, FolderKanban } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ROUTE_PATHS } from "@/routing/domainRoutes";

export function MobileNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const mobileNavItems = [
    { label: t("nav.projects"), path: "/projects", icon: FolderKanban },
    { label: t("nav.schedule"), path: ROUTE_PATHS.schedule, icon: CalendarClock },
    { label: t("nav.dashboard"), path: ROUTE_PATHS.dashboardHome, icon: LayoutDashboard, isPrimary: true },
    { label: t("nav.tickets"), path: "/tickets", icon: FileText },
    { label: t("nav.payments"), path: "/billing", icon: Receipt },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-card border-t safe-area-bottom">
      <div className="flex items-center justify-around h-16">
        {mobileNavItems.map((item) => {
          const isActive =
            item.path === ROUTE_PATHS.dashboardHome
              ? location.pathname === ROUTE_PATHS.dashboardHome
              : location.pathname === item.path || location.pathname.startsWith(item.path + "/");
          if (item.isPrimary) {
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className="flex flex-col items-center justify-center -mt-4"
              >
                <div className="rounded-full bg-accent p-3 shadow-lg">
                  <LayoutDashboard className="h-5 w-5 text-accent-foreground" />
                </div>
                <span className="text-[10px] mt-1 text-muted-foreground">{t("nav.dashboard")}</span>
              </NavLink>
            );
          }
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center gap-0.5 min-w-[56px]"
            >
              <item.icon className={cn("h-5 w-5", isActive ? "text-accent" : "text-muted-foreground")} />
              <span className={cn("text-[10px]", isActive ? "text-accent font-medium" : "text-muted-foreground")}>
                {item.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
